<template>
  <div v-if="channelPartnerTeaser">
    <h3 class="mb-5">
      {{
        $textDictionary['pdp.distributors.modal.title'] ??
        'Choose a distributor'
      }}
    </h3>

    <ImageTextTeasersBlock
      :is-image-stretched="false"
      :teasers="channelPartnerTeaser"
      :cols="channelPartnerCols"
      :cols-centered="false"
      :content-centered="false"
    />
  </div>
</template>

<script setup lang="ts">
import { useProductDetailPageStore } from '~/stores/productDetailPageStore/productDetailPageStore';
import type { ImageTextTeaserInterface } from '@hypercodestudio/basler-components/dist/components/modules/ImageTextTeaser.vue';
import { ImageTextTeasersBlock } from '@hypercodestudio/basler-components';

const store = useProductDetailPageStore();

const SKU_PLACEHOLDER = '{sku}';

const channelPartnerCols = computed(() => {
  if (
    store.decoratedProduct?.channelPartners &&
    store.decoratedProduct?.channelPartners.length === 1
  ) {
    return 4;
  } else if (
    store.decoratedProduct?.channelPartners &&
    store.decoratedProduct?.channelPartners.length === 2
  ) {
    return 6;
  }
  return 8;
});

const { $textDictionary } = useNuxtApp();

const channelPartnerTeaser = computed(() => {
  if (
    !store.decoratedProduct?.channelPartnersData &&
    !store.decoratedProduct?.channelPartnersData
  ) {
    return [];
  }

  return store.decoratedProduct?.channelPartnersData.map<ImageTextTeaserInterface>(
    (channelPartner) => ({
      headline: ensureArray(channelPartner.label.value)[0],
      text: '',
      image: {
        src:
          ensureArray(channelPartner.logourl.value)[0] +
          '&fit=pad&h=150&w=500&bg=rgb:ffffff',
        rgb: '9090ff'
      },
      buttonLink: {
        uri: buildChannelPartnerUrl(
          ensureArray(channelPartner.deepurl.value)[0]
        ),
        target: '_blank'
      },
      buttonText:
        $textDictionary.value['pdp.distributors.modal.buy-here-cta.label'] ??
        'Buy here'
    })
  );
});

function buildChannelPartnerUrl(url: String) {
  return url.replace(SKU_PLACEHOLDER, store.decoratedProduct?.sku ?? '');
}
</script>

<style module>
.distributor-link {
  justify-content: left;
  align-items: start !important;
  text-decoration: none !important;
}

.distributor-cta-text {
  color: grey;
}

.distributor-cta-text::after {
  content: ' >';
}

.distributor-logo {
  width: fit-content !important;
  margin-right: 16px;
  border-radius: 10px;
  border: 1px solid grey;
}

.distributor-logo img {
  width: 100px !important;
  height: 60px !important;
  display: block;
  object-fit: contain;
}
</style>
